"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var AudioManager_1 = require("./AudioManager");
var GameConstants_1 = require("./GameConstants");
var GameManager_1 = require("./GameManager");
var PreLoader = /** @class */ (function (_super) {
    __extends(PreLoader, _super);
    function PreLoader() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    PreLoader.prototype.init = function () {
        PreLoader.currentInstance = this;
        this.load.path = GameConstants_1.GameConstants.ASSETS_PATH;
    };
    PreLoader.prototype.preload = function () {
        this.generateBitmapData();
        this.composeScene();
        this.loadAssets();
    };
    PreLoader.prototype.create = function () {
        GameManager_1.GameManager.init(this.game);
        GZLOADER.unload();
        GameManager_1.GameManager.loadLocalStorage();
        AudioManager_1.AudioManager.getInstance().init(this.game);
        this.game.state.start("SplashState", true, false);
    };
    PreLoader.prototype.updateLoadedPercentage = function () {
        // this.preloadBar.scale.x = this.load.progress / 100 * 3.925;
        // @ts-ignore
        GZLOADER.modify(108, 200);
        // @ts-ignore
        GZLOADER.loadProcess(this.load.progress);
    };
    PreLoader.prototype.composeScene = function () {
        // this.add.sprite(0, 0, "bg");
        // para usar aqui la fuente por primera vez
        this.add.text(-200, -200, "abcdefg", { font: "38px Futura", fill: "#FFFFFF", align: "center" });
        this.add.text(-200, -200, "abcdefg", { font: "38px Eczar", fill: "#FFFFFF", align: "center" });
        // this.loadingItemsContainer = this.add.group();
        // let preloadBarCapsuleShadow: Phaser.Sprite = new Phaser.Sprite(this.game, (GameConstants.GAME_WIDTH / 2 + 2), (600 + 2), this.game.cache.getBitmapData(GameConstants.BLACK_SQUARE));
        // preloadBarCapsuleShadow.scale.set(4, .25);
        // preloadBarCapsuleShadow.anchor.set(.5);
        // preloadBarCapsuleShadow.alpha = .45;
        // this.loadingItemsContainer.add(preloadBarCapsuleShadow);
        // let preloadBarCapsule: Phaser.Sprite = new Phaser.Sprite(this.game, GameConstants.GAME_WIDTH / 2, 600, this.game.cache.getBitmapData(GameConstants.WHITE_SQUARE));
        // preloadBarCapsule.scale.setTo(4, .25);
        // preloadBarCapsule.anchor.set(.5);
        // this.loadingItemsContainer.add(preloadBarCapsule);
        // this.preloadBar = new Phaser.Sprite(this.game, (GameConstants.GAME_WIDTH / 2 - 126) , 600 , this.game.cache.getBitmapData(GameConstants.RED_SQUARE));
        // this.preloadBar.scale.setTo(0, .2);
        // this.preloadBar.anchor.set(0, .5);
        // this.loadingItemsContainer.add(this.preloadBar);
    };
    PreLoader.prototype.loadAssets = function () {
        this.load.json("LevelData", "/cards.json");
        this.load.atlas("texture_atlas_1", "/texture_atlas_1_v2.png", "/texture_atlas_1_v2.json");
        this.load.atlas("texture_atlas_2", "/texture_atlas_2.png", "/texture_atlas_2.json");
        this.load.atlas("texture_atlas_4", "/texture_atlas_4.png", "/texture_atlas_4.json");
        this.load.image("tut_1", "/NewTut/tut_1.png");
        this.load.image("tut_3", "/NewTut/tut_3.png");
        this.load.image("tut_5", "/NewTut/tut_5.png");
        if (GameConstants_1.GameConstants.DEVELOPMENT) {
            this.load.atlas("texture_atlas_0", "/texture_atlas_0.png", "/texture_atlas_0.json");
        }
        this.load.audiosprite("audio-sprite", ["/audio/audiosprite.mp3", "/audio/audiosprite.ogg"], "/audio/audiosprite.json");
        this.load.onFileComplete.add(this.updateLoadedPercentage, this);
    };
    PreLoader.prototype.generateBitmapData = function () {
        var bmd = this.game.add.bitmapData(GameConstants_1.GameConstants.BITMAP_SIZE, GameConstants_1.GameConstants.BITMAP_SIZE, GameConstants_1.GameConstants.RED_SQUARE, true);
        bmd.ctx.beginPath();
        bmd.ctx.rect(0, 0, GameConstants_1.GameConstants.BITMAP_SIZE, GameConstants_1.GameConstants.BITMAP_SIZE);
        bmd.ctx.fillStyle = "#FF0000";
        bmd.ctx.fill();
        bmd = this.game.add.bitmapData(GameConstants_1.GameConstants.BITMAP_SIZE, GameConstants_1.GameConstants.BITMAP_SIZE, GameConstants_1.GameConstants.GREEN_SQUARE, true);
        bmd.ctx.beginPath();
        bmd.ctx.rect(0, 0, GameConstants_1.GameConstants.BITMAP_SIZE, GameConstants_1.GameConstants.BITMAP_SIZE);
        bmd.ctx.fillStyle = "#16332b";
        bmd.ctx.fill();
        bmd = this.game.add.bitmapData(GameConstants_1.GameConstants.BITMAP_SIZE, GameConstants_1.GameConstants.BITMAP_SIZE, GameConstants_1.GameConstants.OLIVE_GREEN_SQUARE, true);
        bmd.ctx.beginPath();
        bmd.ctx.rect(0, 0, GameConstants_1.GameConstants.BITMAP_SIZE, GameConstants_1.GameConstants.BITMAP_SIZE);
        bmd.ctx.fillStyle = "#65aa46";
        bmd.ctx.fill();
        bmd = this.game.add.bitmapData(GameConstants_1.GameConstants.BITMAP_SIZE, GameConstants_1.GameConstants.BITMAP_SIZE, GameConstants_1.GameConstants.BLUE_SQUARE, true);
        bmd.ctx.beginPath();
        bmd.ctx.rect(0, 0, GameConstants_1.GameConstants.BITMAP_SIZE, GameConstants_1.GameConstants.BITMAP_SIZE);
        bmd.ctx.fillStyle = "#0000FF";
        bmd.ctx.fill();
        bmd = this.game.add.bitmapData(GameConstants_1.GameConstants.BITMAP_SIZE, GameConstants_1.GameConstants.BITMAP_SIZE, GameConstants_1.GameConstants.WHITE_SQUARE, true);
        bmd.ctx.beginPath();
        bmd.ctx.rect(0, 0, GameConstants_1.GameConstants.BITMAP_SIZE, GameConstants_1.GameConstants.BITMAP_SIZE);
        bmd.ctx.fillStyle = "#f6f9ee";
        bmd.ctx.fill();
        bmd = this.game.add.bitmapData(GameConstants_1.GameConstants.BITMAP_SIZE, GameConstants_1.GameConstants.BITMAP_SIZE, GameConstants_1.GameConstants.LIGHT_BLUE_SQUARE, true);
        bmd.ctx.beginPath();
        bmd.ctx.rect(0, 0, GameConstants_1.GameConstants.BITMAP_SIZE, GameConstants_1.GameConstants.BITMAP_SIZE);
        bmd.ctx.fillStyle = "#cee3df";
        bmd.ctx.fill();
        bmd = this.game.add.bitmapData(GameConstants_1.GameConstants.BITMAP_SIZE, GameConstants_1.GameConstants.BITMAP_SIZE, GameConstants_1.GameConstants.BLACK_SQUARE, true);
        bmd.ctx.beginPath();
        bmd.ctx.rect(0, 0, GameConstants_1.GameConstants.BITMAP_SIZE, GameConstants_1.GameConstants.BITMAP_SIZE);
        bmd.ctx.fillStyle = "#000000";
        bmd.ctx.fill();
        bmd = this.game.add.bitmapData(GameConstants_1.GameConstants.BITMAP_SIZE, GameConstants_1.GameConstants.BITMAP_SIZE, GameConstants_1.GameConstants.GRAY_SQUARE, true);
        bmd.ctx.beginPath();
        bmd.ctx.rect(0, 0, GameConstants_1.GameConstants.BITMAP_SIZE, GameConstants_1.GameConstants.BITMAP_SIZE);
        bmd.ctx.fillStyle = "#999999";
        bmd.ctx.fill();
        bmd = this.game.add.bitmapData(GameConstants_1.GameConstants.BITMAP_SIZE, GameConstants_1.GameConstants.BITMAP_SIZE, GameConstants_1.GameConstants.YELLOW, true);
        bmd.ctx.beginPath();
        bmd.ctx.rect(0, 0, GameConstants_1.GameConstants.BITMAP_SIZE, GameConstants_1.GameConstants.BITMAP_SIZE);
        bmd.ctx.fillStyle = "#fff17f";
        bmd.ctx.fill();
        bmd = this.game.add.bitmapData(GameConstants_1.GameConstants.BITMAP_SIZE, GameConstants_1.GameConstants.BITMAP_SIZE, GameConstants_1.GameConstants.LEMON_CHIFFON_SQUARE, true);
        bmd.ctx.beginPath();
        bmd.ctx.rect(0, 0, GameConstants_1.GameConstants.BITMAP_SIZE, GameConstants_1.GameConstants.BITMAP_SIZE);
        bmd.ctx.fillStyle = "#FFFACD";
        bmd.ctx.fill();
    };
    return PreLoader;
}(Phaser.State));
exports.PreLoader = PreLoader;
